/* eslint-disable max-classes-per-file */
import { Path } from 'react-hook-form';

import { ApiClientError } from './ApiClientError';
import { BaseOperationResponse, OpResponseCode } from './Kamernet';

export class KamernetError<
  DataType extends object = object,
> extends ApiClientError<DataType> {
  override name = 'KamernetError';

  getHttpStatusCode(): number | undefined {
    // @todo: there shouldn't be any need for casting to BaseOperationResponse
    return (this.data as BaseOperationResponse | null)?.OpResponse
      ?.HttpStatusCode;
  }

  getCode(): OpResponseCode | undefined {
    // @todo: there shouldn't be any need for casting to BaseOperationResponse
    return (this.data as BaseOperationResponse | null)?.OpResponse?.Code;
  }
}

export class KamernetValidationError<PayloadType> extends KamernetError<{
  errors: {
    key: Path<PayloadType>;
  }[];
}> {
  override name = 'KamernetValidationError';
}
